import React, { useEffect, useState } from "react";
import { FiArrowLeft, FiArrowDown, FiArrowRight } from "react-icons/fi";
import { FaHouseUser, FaConciergeBell } from "react-icons/fa";
import { BsCheck2All } from "react-icons/bs";
import { BiError } from "react-icons/bi";
import { MdScheduleSend } from "react-icons/md";
import { colors } from "../../styles/style";
const RowItem = (props) => {
  const [hour, setHour] = useState("");
  const [idOrder, setIdOrder] = useState("");
  const [order, setOrder] = useState();
  //console.log("Datos de la orden", order?.reminders);

  // We need ref in this, because we are dealing
  // with JS setInterval to keep track of it and
  // stop it when needed
  // The state for our timer
  useEffect(() => {
    setHour(props.hour);
    setIdOrder(props.idOrder);
    setOrder(props.order);
    //checkReminders(props.order);
  }, [props]);

  function getColorButtonByLevel(level) {
    const txt = {
      NUEVA: "btn btn-primary",
      "EN PROCESO": "btn btn-warning",
      "EN TRANSITO": "btn btn-success",
      FINALIZADO: "btn btn-secondary",
    };
    return txt[level] || "btn btn-secondary";
  }

  function getDescriptionbyStatus(status) {
    const txt = {
      ENVIADA: "Enviada",
      LISTO: "Espera de repartidor",
      "EN TRANSITO": "En camino a la tienda",
      "LLEGUE-P-R": "Repartidor en tienda",
      "EN CAMINO ": "En camino con el cliente",
      "LLEGUE-P-C": "Repartidor en domicilio",
      FINALIZADO: "Orden finalizada",
    };
    return txt[status] || "Por definir";
  }

  function getOrderType() {
    let toGetType = "";
    if (order.shop_comments)
      toGetType =
        order.shop_comments === "WISHES"
          ? order.shop_comments
          : order.shop_comments === "WISHES"
          ? order.shop_comments
          : order.order_type.toUpperCase();
    else toGetType = order.order_type.toUpperCase();

    const special = {
      WISHES: "Niku deseo",
      SOLUTIONS: "Niku mandado",
      PRODUCTO: "Delivery",
      SERVICE: "Servicio",
    };
    return special[toGetType] || "Por definir";
  }

  function renderIconByStatus() {
    switch (order.status) {
      case "ENVIADA":
        return <MdScheduleSend size={20} color={colors.WHITE_COLOR} />;
        break;
      case "LISTO":
        return <FaConciergeBell size={20} color={colors.WHITE_COLOR} />;
        break;
      case "EN TRANSITO":
        return <FiArrowLeft size={20} color={colors.WHITE_COLOR} />;
        break;
      case "LLEGUE-P-R":
        return <FiArrowDown size={20} color={colors.WHITE_COLOR} />;
        break;
      case "EN CAMINO":
        return <FiArrowRight size={20} color={colors.WHITE_COLOR} />;
        break;
      case "LLEGUE-P-C":
        return <FaHouseUser size={20} color={colors.WHITE_COLOR} />;
        break;
      case "FINALIZADO":
        return <BsCheck2All size={20} color={colors.WHITE_COLOR} />;
        break;
      default:
        return <BiError size={20} color={colors.WHITE_COLOR} />;
        break;
    }
  }

  return (
    <>
      {order && (
        <tr>
          <th scope="row"># {idOrder.substring(0, 6)}</th>
          <td className="text-center">
            {hour.substring(0, 10)}{" "}
            {new Date(hour)
              .toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })
              .substring(0, 5)}
          </td>
          <td>{getOrderType()}</td>
          <td>
            {order.customer_id.name != null
              ? order.customer_id.name + " " + order.customer_id.last_name
              : "undefined"}
          </td>
          <td>
            {order.shop_id != null ? order.shop_id.shop_name : "undefined"}
          </td>
          <td>{getDescriptionbyStatus(order.status)}</td>
          <td className="text-center">
            <button
              type="button"
              className={getColorButtonByLevel(order.level)}
              onClick={() => props.selectOrder(order)}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {renderIconByStatus()}
              </div>
            </button>
          </td>
        </tr>
      )}
    </>
  );
};

export default RowItem;
